import React from 'react'
import { Box, Flex, TextBox } from '@revolut/ui-kit'
import { FieldArray } from 'formik'
import styled from 'styled-components'

import { AccountDisplay } from 'components/AccountDisplay/AccountDisplay'
import { Pocket } from 'types/common'

const GroupBox = styled(Box)`
  &:first-child {
    margin-top: 0;
  }
`

type RenderPocketGroupProps = {
  type: Pocket['type']
  groupHeaderText: string
  approvedGroupHeaderText: string
  icon?: React.ReactNode
  showName?: boolean
  pockets: Pocket[]
  consentedPocketIds: string[]
  values: string[]
}

export const PocketGroup = ({
  type,
  groupHeaderText,
  approvedGroupHeaderText,
  icon,
  showName = false,
  pockets,
  consentedPocketIds,
  values,
}: RenderPocketGroupProps) => {
  // All the pockets we have for this group
  const currentActiveGroupPockets = pockets.filter(
    (pocket) => pocket.state === 'ACTIVE' && pocket.type === type,
  )
  const hasGroupPockets = currentActiveGroupPockets.length > 0
  const hasApprovedPockets = consentedPocketIds.length > 0
  // All approved group pockets if any
  const approvedGroupPockets = hasApprovedPockets
    ? currentActiveGroupPockets.filter(({ id }) => consentedPocketIds.includes(id))
    : []
  const hasApprovedGroupPockets = approvedGroupPockets.length > 0
  // If there's no pockets in group or
  // there are approved pockets globally, but none in the group
  if (!hasGroupPockets || (hasApprovedPockets && !hasApprovedGroupPockets)) {
    return null
  }
  const collection = hasApprovedGroupPockets
    ? approvedGroupPockets
    : currentActiveGroupPockets
  return (
    <GroupBox mt={4}>
      <Flex py='.5rem' justifyContent='flex-start' mb='1rem'>
        <TextBox color='black' fontWeight={500} minWidth='16rem'>
          {hasApprovedGroupPockets ? approvedGroupHeaderText : groupHeaderText}
        </TextBox>
      </Flex>
      <FieldArray name='pockets'>
        {({ push, remove }) =>
          collection.map((pocket) => (
            <AccountDisplay
              key={pocket.id}
              account={pocket}
              icon={icon}
              name={showName ? pocket.name : undefined}
              onToggle={
                !hasApprovedGroupPockets
                  ? (id, checked) => {
                      if (checked) {
                        push(id)
                      } else {
                        const idIndex = values.indexOf(id)
                        remove(idIndex)
                      }
                    }
                  : undefined
              }
              selectedAccountIds={!hasApprovedGroupPockets ? values || [] : undefined}
            />
          ))
        }
      </FieldArray>
    </GroupBox>
  )
}
